import { render, staticRenderFns } from "./OrderDetailTabPayments.vue?vue&type=template&id=14daea7e"
import script from "./OrderDetailTabPayments.vue?vue&type=script&lang=js"
export * from "./OrderDetailTabPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports